export const PARAMS = {
  SURVEY_STEP: 'surveyStep',
  SURVEY_ID: 'surveyId',
};
